import React, { Component } from "react";
import PropTypes from "prop-types";
import Validator from "validator";
import { NotificationManager } from "react-notifications";
import { FormGroup, Button } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import NProgress from "nprogress";
import InlineError from "../../messages/InlineError";
import UserService from "../../../services/UserService";
import LoaderInline from "../../helpers/LoaderInline";

class ForgotPasswordPage extends Component {
	state = {
		data: {
			email: ""
		},
		loading: false,
		errors: {}
	};
	onChange = (e) => {
		this.setState({ data: { ...this.state.data, [e.target.name]: e.target.value } });
	};

	onSubmit = (e) => {
		e.preventDefault();
		NProgress.start();
		const errors = this.validate(this.state.data);
		this.setState({ errors });
		if (Object.keys(errors).length === 0) {
			this.setState({ loading: true });
			new UserService(this).forgot_password(this.state.data)
				.then((res) => {
					this.setState({ loading: false });
					if(res.data.success === true) {
						NotificationManager.success("An email with reset password link is sent to your inbox.", "Success!");
						NProgress.done();
						this.props.history.push("/");
					} else {
						NotificationManager.error("Email not found.", "Error!");
						NProgress.done();
						this.setState({ ...this.state, errors: { ...this.state.errors, message: "Email not found!" }, loading: false });              
					}
				}).catch((err) => {
					NProgress.done();
					this.setState({ ...this.state, errors: { ...this.state.errors, message: "Something went wrong!" }, loading: false });
				});
		} else {
			NProgress.done();
		}
	}

	validate = (data) => {
		const errors = {};
		if (!Validator.isEmail(data.email)){ errors.email = "Invalid email"; } 
		return errors;
	};

	render() {
		const { data, errors, loading } = this.state;
		return (
			<div className="centerize-container">
				<div className="table-row">
					<div className="table-cell">
						<div className="login-wrapper fadeInLoadUp">
							<h1 className="text-center"><b>TASK</b> 3.0</h1>
							<div className="form-wrapper">
								<h2 className="text-center">Forgot password</h2>
								<form onSubmit={this.onSubmit}>
									<FormGroup validationState={errors.email && "error"}>
										<div className="input-group">
											<input required type="email" className="form-control" id="username" placeholder="Email" name="email" value={data.email} onChange={this.onChange} />
											<div className="input-group-addon">
												<i className="material-icons">mail_outline</i>
											</div>
										</div>
										{errors.email && <InlineError text={errors.email} />}
									</FormGroup>
									{errors.message && <span className="text-danger alert-message">{errors.message}</span>}
									
									<div className="row">
										<div className="col-sm-12">
											<Button bsStyle="primary" className="btn-block" type="submit" disabled={loading} onClick={this.onSubmit}>
												{loading ? <LoaderInline width="20" height="20" color="#fff"/> : "Send link"}
											</Button>
										</div>
									</div>
								</form>
								<div className="footer-links">
									<Link to="/login" className="btn-block btn-link">Back to login</Link>
								</div>
								<div className="clearfix" />
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
ForgotPasswordPage.propTypes = {
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired
};
export default withRouter(ForgotPasswordPage);


// WEBPACK FOOTER //
// ./src/components/pages/public-pages/ForgotPasswordPage.js